import { BoxProps, ButtonGroup } from '@mui/material'
import styled from 'styled-components'

interface BtnGroupProps extends BoxProps {
  isRoadMap?: boolean
}

export const BtnGroupFloor = styled(ButtonGroup).withConfig<BtnGroupProps>({
  shouldForwardProp: (prop) => prop !== 'isRoadMap',
})`
  margin-bottom: 11px;
  background: ${(props) =>
    props.isRoadMap ? 'rgba(142, 145, 143, 0.555)' : '#FFFFFF33'};
  bottom: 57px;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  border-radius: 100px;
  padding: 10px 5px;
  backdrop-filter: blur(4px);
  box-shadow: 0px 0px 8px 0px #ffffff33 inset;
  box-shadow: 0px 0px 12px 0px #0000001a;

  .MuiButtonGroup-grouped {
    padding: 0;
    width: 38px;
    height: 38px;
    min-height: 30px;
    min-width: 30px;
    font-weight: 500;
    font-size: 12px;
    line-height: 30px;
    border-radius: 50%;
    margin-top: 3px;
    margin-bottom: 3px;
    &:not(:last-of-type) {
      border-bottom: none;
    }
    background-color: #ffffff;
    color: #000000;
    text-align: center;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;

    &.MuiButton-contained {
      color: #ffffff;
      background-color: #004744;
    }
  }
`

export default BtnGroupFloor
